import { useCallback, useRef, useState } from 'react'
import { clear as clearDb, createStore, del, get, set } from 'idb-keyval'

const useCache = (key, dbName = 'give-cache', storeName = 'give-store') => {
  const storeRef = useRef(null)
  const dbParamsRef = useRef({ dbName: null, storeName: null })

  // Only create a new store if we don't have one or if the db parameters changed
  if (!storeRef.current || dbParamsRef.current.dbName !== dbName || dbParamsRef.current.storeName !== storeName) {
    storeRef.current = createStore(dbName, storeName)
    dbParamsRef.current = { dbName, storeName }
  }

  const [error, setError] = useState(null)

  const getItem = useCallback(async () => {
    if (!storeRef?.current) return null
    try {
      const result = await get(key, storeRef.current)
      setError(null)
      return result
    } catch (err) {
      setError(err)
      return null
    }
  }, [key])

  const setItem = useCallback(
    async (value) => {
      if (!storeRef?.current) return
      try {
        await set(key, value, storeRef.current)
        setError(null)
      } catch (err) {
        setError(err)
      }
    },
    [key]
  )

  const removeItem = useCallback(async () => {
    if (!storeRef?.current) return
    try {
      await del(key, storeRef.current)
      setError(null)
    } catch (err) {
      setError(err)
    }
  }, [key])

  const clear = useCallback(async () => {
    if (!storeRef?.current) return
    try {
      await clearDb(storeRef.current)
      setError(null)
    } catch (err) {
      setError(err)
    }
  }, [])

  return { error, clear, getItem, removeItem, setItem }
}

export default useCache
